import { inject, Injectable } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { from, map, Observable, switchMap, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NCALayerClient } from 'ncalayer-js-client';
import { NcalayerCancelledError } from './ncalayer-cancelled-error';
import { NcalayerUnavailableError } from './ncalayer-unavailable-error';

@Injectable({
  providedIn: 'root'
})
export class NcalayerService {
  private readonly translate = inject(TranslateService);
  private ncaClient: NCALayerClient | null = null;
  private isConnected = false;

  signXml(xmlData: string, isAuth = false): Observable<string> {
    return this.connectIfNeeded().pipe(
      switchMap(() =>
        from(
          this.ncaClient!.basicsSignXML(
            NCALayerClient.basicsStorageAll,
            xmlData,
            NCALayerClient.basicsXMLParams,
            isAuth ? NCALayerClient.basicsSignerAuthAny : NCALayerClient.basicsSignerSignAny
          )
        )
      ),
      map((signedXml) => (Array.isArray(signedXml) ? signedXml[0] : signedXml)),
      catchError((error) => {
        if (error instanceof NcalayerUnavailableError) {
          return throwError(() => error);
        }
        if (String(error?.message ?? error).includes('CANCELLED')) {
          return throwError(() => new NcalayerCancelledError());
        }
        console.error('Ошибка подписи XML:', error);
        return throwError(() => new Error(this.translate.instant('ncalayer.signError')));
      })
    );
  }

  private connectIfNeeded(): Observable<void> {
    if (this.ncaClient && this.isConnected) {
      return from(Promise.resolve());
    }

    this.ncaClient = new NCALayerClient('wss://127.0.0.1:13579');

    return from(this.ncaClient.connect()).pipe(
      map(() => {
        this.isConnected = true;
      }),
      catchError((error) => {
        console.error('Ошибка подключения к NCALayer:', error);
        this.isConnected = false;
        return throwError(() => new NcalayerUnavailableError());
      })
    );
  }
}
